import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {BeforeCloseEventArgs} from "@syncfusion/ej2-popups/src/dialog/dialog";
import {UtilService} from "../../services/util/util.service";

@Component({
  selector: 'sb-cron-expression-input',
  templateUrl: './cron-expression-input.component.html',
  styleUrls: ['./cron-expression-input.component.scss']
})
export class CronExpressionInputComponent implements OnInit {

  @ViewChild('cronExpressionDialog', {static: false}) ejDialog: DialogComponent;

  @Input()
  expression: string = "";

  // Used for binding in knockout context
  @Input()
  onExpressionChangedCommand: (expression: string) => void;

  initialExpression: string = "";

  public visible = false;

  public position: any = { X: 'center', Y: 'center' };

  public buttons: ButtonPropsModel[] = [
    {
      'click': this.hideDialog.bind(this, false),
      buttonModel: {
        content: 'Cancel',
      }
    },
    {
      'click': this.hideDialog.bind(this, true),
      buttonModel: {
        content: 'Save',
        isPrimary: true,
      }
    },
  ];

  constructor(private utilService: UtilService) { }

  ngOnInit(): void {
    this.initialExpression = this.expression;
  }

  onExpressionChange(expression: string) {
    this.expression = expression;

    if (this.onExpressionChangedCommand) {
      this.onExpressionChangedCommand(expression);
    }
  }

  onChange(event: Event) {
    this.expression = (event.target as HTMLInputElement).value || "";
    this.onExpressionChange(this.expression);
  }

  showModal() {
    this.visible = true;

    // Give the dialog a chance to build (as there is an ngIf around it)
    this.utilService.tickThen(() => {
      this.ejDialog.show();
    });
  }

  hideDialog(save: boolean) {
    this.ejDialog.hide();
    this.visible = false;

    if (save) {
      this.onExpressionChange(this.expression);
    } else {
      this.onExpressionChange(this.initialExpression);
    }
  }

  onBeforeClose($event: BeforeCloseEventArgs) {
    if ($event.closedBy == "close icon" || $event.closedBy == "escape") {
      this.onExpressionChange(this.initialExpression);
    }
  }
}
